<template>
    <div>
        <p>This is a <code>.dmg</code> file which appears as a volume in Mac OSX. GanttProject application
            comes with bundled <a href="https://bell-sw.com/pages/java-11/" target="_blank">LibericaFX 11.0.7</a>
            Java Runtime, it is properly signed and notarized.
            Just double click it to launch. Optionally, you may drag GanttProject into Applications.</p>

        <div class="p-3">
            <strong>GanttProject {{ version }}</strong>
            <div class="help-text pb-3">Released on {{ releaseDate }}</div>
            <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/mac`">Download</a>
        </div>

        <p>This was smoke-tested with the following macOS versions:</p>

        <ul>
            <li>macOS Catalina 10.15.4</li>
            <li>macOS Mojave 10.14.6</li>
        </ul>
        <p>If you're having troubles with launching GanttProject using this package, you can try using
            a <a :href="`/dl/${version}/any`">platform-independent ZIP archive</a>
            which provides <code>ganttproject.command</code> shell script for launching. ZIP distro requires
            Java Runtime (JRE) to be installed. You can download Java for macOS from multiple vendors, e.g.
            <a href="https://bell-sw.com/pages/java-14.0.1/" target="_blank">BellSoft Liberica</a>,
            <a href="https://www.azul.com/downloads/zulu-community/?version=java-11-lts&os=macos&architecture=x86-64-bit&package=jre-fx" target="_blank">Azul Zulu</a>,
            and others.
        </p>
    </div>
</template>

<script>
    export default {
        name: "DownloadMac28",
        props: {
            releaseDate: String,
            version: String,
        }
    }
</script>

<style scoped>

</style>
